import { render, staticRenderFns } from "./applyForTestDialog.vue?vue&type=template&id=1ecdb4f3&scoped=true&"
import script from "./applyForTestDialog.vue?vue&type=script&lang=js&"
export * from "./applyForTestDialog.vue?vue&type=script&lang=js&"
import style0 from "./applyForTestDialog.vue?vue&type=style&index=0&id=1ecdb4f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdb4f3",
  null
  
)

export default component.exports